<template>
  <v-dialog v-model="show" width="800">
    <v-card>
      <v-card-title class="d-flex align-center">
        <div>{{ $tc('forecast_violation', 2) }}</div>
        <v-spacer/>
        <v-btn fab text small @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list v-if="size(errorMessages) > 0">
          <v-list-item v-for="(error, index) in errorMessages" :key="index">
            <v-list-item-icon>
              <v-icon large color="warning">mdi-alert-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                {{ error.route_product.product.name }} - No forecast available
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap" v-html="$t(error.error_message, { productName:error.route_product.product.name })" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-if="size(forecastViolations) > 0">
          <v-list-item v-for="(violation, index) in forecastViolations" :key="index">
            <v-list-item-icon>
              <v-icon large color="primary">mdi-crystal-ball</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-wrap">
                {{ violation.route_product.label }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-wrap">
                {{ violation.formattedMessage }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <template #activator="{on, attrs}">
      <div class="ml-5" v-if="totalDisplayItems > 0">
        <vf-tooltip :text="$tc('forecast_violation', 2)">
          <v-badge :content="totalDisplayItems" offset-x="13" offset-y="13" overlap color="warning darken-1" bordered>
            <v-btn small fab dark v-on="on" v-bind="attrs" color="warning" elevation="0">
              <v-icon size="30">
                mdi-weather-cloudy-alert
              </v-icon>
            </v-btn>
          </v-badge>
        </vf-tooltip>
      </div>
    </template>
  </v-dialog>
</template>

<script>
import VfTooltip from '@/components/shared/VfTooltip'
import { size, get } from 'lodash'
export default {
  name: 'ForecastViolationsDialog',
  components: {
    VfTooltip
  },
  props: {
    // The route to display
    route: Object,
    // The error messages to display (if the forecast data couldn't be loaded)
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    forecastViolations () {
      return get(this.route, 'forecast_route_violations')
    },
    totalDisplayItems () {
      return size(this.forecastViolations) + size(this.errorMessages)
    }
  },
  methods: {
    size: size
  }
}
</script>

<style scoped>

</style>
